import {
    createContext,
    useContext,
    useState,
    useEffect,
    useCallback,
} from "react";
import { Button, Col, Row, Container } from "react-bootstrap";
import Loader2 from "../../../components/Loader2.jsx";
import TransactionsList from "./components/TransactionsList.jsx";
import UploadExcelModal from "./components/TransactionModal.jsx";
import api from "../../../service/api.js";
import NotyfContext from "../../../contexts/NotyfContext.jsx";
import { uploadBankTransaction, fetchUnpaidInvoices } from "./hooks/api.js";
import AssignSalespersonModal from "./components/AssignSalespersonModal.jsx";
import TransactionSearch from "./components/TransactionSearch.jsx";

export const ContextProvider = createContext(null);

export default function BankTransactions() {
    const notyf = useContext(NotyfContext);

    const context = null;
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [data, setData] = useState([]);

    const [showSalesModal, setShowSalesModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const [showUploadModal, setShowUploadModal] = useState(false);
    const [search, setSearchValue] = useState({
        transaction_id: "",
        status: "",
        company: "",
        start_date: null,
        end_date: null,
    });


    const handleUpload = async (formData) => {
        await api.post("tms/bank-transaction/upload", formData);
        notyf?.success("File uploaded successfully!");
    };

    const handleOpenSalesModal = (row) => {
        setSelectedRow(row);
        setShowSalesModal(true);
    };
    const getTransaction = useCallback(async (search) => {
        try {
            setError("");
            setLoading(true);
            const response = await fetchUnpaidInvoices(search);
            setData(response);
        } catch (error) {
            setError(
                error.message || "An error occured during fetching of data."
            );
            setLoading(false);
            return null;
        }
        setLoading(false);
    }, []);

    useEffect(() => {
        getTransaction(search);
    }, [getTransaction]);


    return (
        <ContextProvider.Provider value={context}>
            <Container fluid>
                <Row>
                    <Col md={12}>
                        <TransactionSearch
                            setSearchValue={setSearchValue}
                            searchValue={search}
                            onSearch={() => getTransaction(search)}

                        ></TransactionSearch>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <h3 className="fw-bolder m-0">Bank Transactions</h3>
                    </Col>
                </Row>

                <Row className="mt-3 mb-4">
                    <Col md={12} className="d-flex justify-content-end">
                        <Button onClick={() => setShowUploadModal(true)}>
                            Upload Excel
                        </Button>
                    </Col>
                </Row>

                <Row>
                    <Col xxl={12}>
                        {loading ? (
                            <div className="text-center py-5">
                                <Loader2 />
                            </div>
                        ) : (
                            <TransactionsList
                                transaction={data}
                                onAssignSalesperson={handleOpenSalesModal}
                            />
                        )}
                    </Col>
                </Row>

                <UploadExcelModal
                    show={showUploadModal}
                    onClose={() => setShowUploadModal(false)}
                    onSubmit={handleUpload}
                />
                <AssignSalespersonModal
                    show={showSalesModal}
                    onHide={() => setShowSalesModal(false)}
                    row={selectedRow}
                    onUpdated={getTransaction}
                />
            </Container>
        </ContextProvider.Provider>
    );
}
